import { VStack, Text, Box, Icon } from "@chakra-ui/react";
import { FaArrowsAltH } from "react-icons/fa";

export default function AccountAutoSettingNotes() {
  return (
    <VStack
      alignItems="flex-start"
      backgroundColor="blackAlpha.100"
      width={"100%"}
      pl="3"
      pt="5"
      rounded="md"
      fontSize="sm"
    >
      <Text fontWeight="semibold" pt="3">
        Notes:
      </Text>
      <Box pl="2">
        <Text>
          1. When multiple accounts match we will match to the oldest account
        </Text>
        <Text>
          2. If multiple values are present in the account field, Inflection
          will consider all the values and will consider that account for
          matching.
        </Text>
        <Text pl="4">
          (Inflection can detect multiple values from space or comma delimited
          text fields)
        </Text>
        <Text>
          3. Inflection will rematch contacts if the values in either of the
          matching fields change.
        </Text>
        <Text>
          4. Inflection will always use the Contact{" "}
          <Icon as={FaArrowsAltH} pt="1" /> Account matching in the CRM. This
          setting is only for Contacts in Inflection that are not matched to an
          Account in the CRM.
        </Text>
        <Text>
          5. The Contact Domain field is auto-generated by Inflection by
          extracting the domain from the Contact's email address. You can use
          the CRM Account Website field to match to the Inflection Contact
          Domain field. Inflection will extract only the root domain from the
          Website field ("https//www.inflection.io/home.html" in Website will
          match "inflection.io" in Domain).
        </Text>
      </Box>
      <Box pt="10" />
    </VStack>
  );
}
